import type { App } from 'vue';
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-audits-feature/partials/AuditFeed',
            () => import('./partials/AuditFeed.vue')
        );

        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-audits-feature/partials/AuditExpandDisplay',
            () => import('./partials/AuditExpandDisplay.vue')
        );
    },
};
